import { HomeIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { TypeTile } from "Components/Analyses/_Shared/TypeTile";
import { BriefcaseIcon, ChildIcon, FinancialSuccessIcon, RefundIcon, SeniorIcon, TargetIcon } from "Components/_Shared/Icons/Icons";
import { IncomeIncomeType } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { FC } from "react";

type Props = {
  readonly incomeType: IncomeIncomeType;
  readonly disabled?: boolean;
};

const getIcon = (incomeType: IncomeIncomeType) => {
  switch (incomeType) {
    case IncomeIncomeType.employment:
      return <BriefcaseIcon />;
    case IncomeIncomeType.self_employment:
      return <FinancialSuccessIcon />;
    case IncomeIncomeType.rental:
      return <HomeIcon />;
    case IncomeIncomeType.parental:
      return <ChildIcon />;
    case IncomeIncomeType.pension:
      return <SeniorIcon />;
    case IncomeIncomeType.disability:
      return <SeniorIcon />;
    case IncomeIncomeType.orphan_or_widow_pension:
      return <RefundIcon />;
    case IncomeIncomeType.other:
      return <TargetIcon />;
  }
};

export const getIncomeTypeResource = (incomeType: IncomeIncomeType) => {
  switch (incomeType) {
    case IncomeIncomeType.employment:
      return Resources.AnalysisDetail.Budget.Incomes.IncomeTypes.Employment;
    case IncomeIncomeType.self_employment:
      return Resources.AnalysisDetail.Budget.Incomes.IncomeTypes.SelfEmployment;
    case IncomeIncomeType.rental:
      return Resources.AnalysisDetail.Budget.Incomes.IncomeTypes.Rental;
    case IncomeIncomeType.parental:
      return Resources.AnalysisDetail.Budget.Incomes.IncomeTypes.Parental;
    case IncomeIncomeType.pension:
      return Resources.AnalysisDetail.Budget.Incomes.IncomeTypes.Pension;
    case IncomeIncomeType.disability:
      return Resources.AnalysisDetail.Budget.Incomes.IncomeTypes.Disability;
    case IncomeIncomeType.orphan_or_widow_pension:
      return Resources.AnalysisDetail.Budget.Incomes.IncomeTypes.OrphanOrWidowPension;
    case IncomeIncomeType.other:
      return Resources.AnalysisDetail.Budget.Incomes.IncomeTypes.Other;
  }
};

// One income type in the drawer's RadioGroup, the same tile as the other type pickers.
export const IncomeTypeTile: FC<Props> = ({ incomeType, disabled = false }) => {
  const { t } = useResource();
  const icon = getIcon(incomeType);

  return <TypeTile value={incomeType} disabled={disabled} icon={icon} label={t(getIncomeTypeResource(incomeType))} />;
};
